import { createContext, ReactNode, useContext, useState } from "react";
import { useMount } from "react-use";
import { LocalConfig } from "../../utils/localConfig";
import { useSanityAuth } from "../sanityAuth/useSanityAuth";

interface EditInSanityContextI {
  editMode: boolean;
  toggle: () => void;
}

const initialValue: EditInSanityContextI = {
  editMode: false,
  toggle: () => null,
};

const Context = createContext<EditInSanityContextI>(initialValue);

export const useEditInSanityContext = () => useContext(Context);

interface Props {
  children: ReactNode;
}

export const EditInSanityContextProvider = (props: Props) => {
  const [editMode, setEditMode] = useState(initialValue.editMode);
  const sanityAuth = useSanityAuth();

  useMount(() => {
    const storedState = LocalConfig.getConfig().editMode;
    return setEditMode(storedState);
  });

  const toggle = () => {
    const nextState = !editMode;
    LocalConfig.setConfig({ editMode: nextState });
    setEditMode(nextState);
  };

  return (
    <Context.Provider
      value={{
        editMode: editMode && sanityAuth.isAuthenticated, // Checking if you are authenticated to make sure you are not stuck in a state where editMode is on but you are not able to turn it off
        toggle,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
